import React, { Component, Fragment } from 'react';
import moment from 'moment-hijri';

const hijri = [
  'محرم',
  'صفر',
  'ربیع‌الاول',
  'ربیع‌الثانی',
  'جمادی‌الاول',
  'جمادی‌الثانی',
  'رجب',
  'شعبان',
  'رمضان',
  'شوال',
  'ذوالقعده',
  'ذوالحجه'
];

export default class MomentHijri extends Component {
  render() {
    return (
      <Fragment>
        {`${hijri[moment(this.props.date, 'YYYY/MM/DD').iMonth()]} ${moment(this.props.date, 'YYYY/MM/DD').iYear()} ${moment(this.props.date, 'YYYY/MM/DD').iDate()}`}
      </Fragment>
    );
  }
} 